import React, { useState, useEffect } from "react";
import { submitContact } from "../services/contactService"; // API call function

const ContactComp = () => {
    const [contact, setContact] = useState({
        name: "",
        email: "",
        subject: "",
        phoneNumber: "",
        message: "",
        captchaInput: "",
    });

    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [message, setMessage] = useState("");

    // CAPTCHA State
    const [captcha, setCaptcha] = useState({ num1: 0, num2: 0, result: 0 });

    // Generate New CAPTCHA
    useEffect(() => {
        generateCaptcha();
    }, []);

    const generateCaptcha = () => {
        const num1 = Math.floor(Math.random() * 10) + 1;
        const num2 = Math.floor(Math.random() * 10) + 1;
        setCaptcha({ num1, num2, result: num1 + num2 });
    };

    // Handle form input changes
    const handleChange = (e) => {
        setContact({ ...contact, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        // CAPTCHA Validation
        if (parseInt(contact.captchaInput) !== captcha.result) {
            setMessage("❌ Incorrect CAPTCHA. Please try again.");
            generateCaptcha(); // Refresh CAPTCHA
            setLoading(false);
            return;
        }

        try {
            const result = await submitContact(contact);
            if (result.success) {
                setMessage("✅ Message sent successfully!");
                setContact({ name: "", email: "", subject: "", phoneNumber: "", message: "", captchaInput: "" });
            } else {
                setMessage(result.message);
            }
        } catch (error) {
            setMessage("❌ Error connecting to the server.");
        }

        setLoading(false);
        generateCaptcha(); // Refresh CAPTCHA
    };

    return (
        <div className="contact">
            <div className="container">
                <div className="row align-items-center">
                    {/* Form Section */}
                    <div className="col-md-8">
                        <div className="contact-form">
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Your Name"
                                            name="name"
                                            value={contact.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Your Email"
                                            name="email"
                                            value={contact.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Subject"
                                            name="subject"
                                            value={contact.subject}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Phone Number"
                                            name="phoneNumber"
                                            value={contact.phoneNumber}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <textarea
                                        className="form-control"
                                        rows="5"
                                        placeholder="Message"
                                        name="message"
                                        value={contact.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>

                                {/* CAPTCHA */}
                                <div className="form-group">
                                    <label>🔢 Solve this: {captcha.num1} + {captcha.num2} = ?</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="captchaInput"
                                        placeholder="Enter CAPTCHA Answer"
                                        value={contact.captchaInput}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div>
                                    <button className="btn" type="submit" disabled={loading}>
                                        {loading ? "Sending..." : "Send Message"}
                                    </button>
                                </div>
                            </form>
                            
                            {/* Response Message */}
                            {message && <p className="mt-3 alert alert-info">{message}</p>}
                        </div>
                    </div>

                    {/* Contact Info Section */}
                    <div className="col-md-4">
                        <div className="contact-info">
                            <h3><i class="fas fa-phone-alt"></i> Get in Touch</h3>
                            <p className="mb-4">
                            Have questions, feedback, or inquiries? We’d love to hear from you! Fill out the contact form, and our team will get back to you as soon as possible.
                            </p>
                            <p><i class="fas fa-map-marker-alt"></i> Address: Ashok Nagar, Ambala, HR, Ind</p>
                            <p><i class="fas fa-envelope"></i> Email: <a href="mailto:support@factbazaar.com">Support Factbazaar</a></p>

                            {/* Social Media Icons (Click-only) */}
                            <div className="social">
                                <a href=""><i className="fab fa-twitter"></i></a>
                                <a href=""><i className="fab fa-facebook-f"></i></a>
                                <a href=""><i className="fab fa-linkedin-in"></i></a>
                                <a href=""><i className="fab fa-instagram"></i></a>
                                <a href=""><i className="fab fa-youtube"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactComp;
